/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { CompanyAddress } from './';
import {
    CompanyAddressFromJSON,
    CompanyAddressFromJSONTyped,
    CompanyAddressToJSON,
} from './';
import type { SyncComparison } from './';
import {
    SyncComparisonFromJSON,
    SyncComparisonFromJSONTyped,
    SyncComparisonToJSON,
} from './';
import type { VatStatus } from './';
import {
    VatStatusFromJSON,
    VatStatusFromJSONTyped,
    VatStatusToJSON,
} from './';

/**
 * 
 * @export
 * @interface AdminCompanyLegalInformationResource
 */
export interface AdminCompanyLegalInformationResource {
    /**
     * The company ID that was passed in the request
     * @type {string}
     * @memberof AdminCompanyLegalInformationResource
     */
    companyId: string;
    /**
     * 
     * @type {string}
     * @memberof AdminCompanyLegalInformationResource
     */
    name?: string;
    /**
     * 
     * @type {CompanyAddress}
     * @memberof AdminCompanyLegalInformationResource
     */
    hqAddress?: CompanyAddress;
    /**
     * 
     * @type {CompanyAddress}
     * @memberof AdminCompanyLegalInformationResource
     */
    billingAddress?: CompanyAddress;
    /**
     * 
     * @type {string}
     * @memberof AdminCompanyLegalInformationResource
     */
    hqRegistrationNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminCompanyLegalInformationResource
     */
    billingRegistrationNumber?: string;
    /**
     * 
     * @type {Date}
     * @memberof AdminCompanyLegalInformationResource
     */
    updatedDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof AdminCompanyLegalInformationResource
     */
    vatNumber?: string;
    /**
     * 
     * @type {VatStatus}
     * @memberof AdminCompanyLegalInformationResource
     */
    vatStatus?: VatStatus;
    /**
     * 
     * @type {string}
     * @memberof AdminCompanyLegalInformationResource
     */
    syncStatus?: AdminCompanyLegalInformationResourceSyncStatusEnum;
    /**
     * 
     * @type {SyncComparison}
     * @memberof AdminCompanyLegalInformationResource
     */
    syncComparison?: SyncComparison;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminCompanyLegalInformationResource
     */
    providers?: Array<AdminCompanyLegalInformationResourceProvidersEnum>;
}


/**
 * @export
 */
export const AdminCompanyLegalInformationResourceSyncStatusEnum = {
    Match: 'MATCH',
    Unsync: 'UNSYNC',
    PartialMatch: 'PARTIAL_MATCH'
} as const;
export type AdminCompanyLegalInformationResourceSyncStatusEnum = typeof AdminCompanyLegalInformationResourceSyncStatusEnum[keyof typeof AdminCompanyLegalInformationResourceSyncStatusEnum];

/**
 * @export
 */
export const AdminCompanyLegalInformationResourceProvidersEnum = {
    Pappers: 'PAPPERS',
    NorthData: 'NORTH_DATA',
    Inpi: 'INPI',
    Legacy: 'LEGACY'
} as const;
export type AdminCompanyLegalInformationResourceProvidersEnum = typeof AdminCompanyLegalInformationResourceProvidersEnum[keyof typeof AdminCompanyLegalInformationResourceProvidersEnum];


/**
 * Check if a given object implements the AdminCompanyLegalInformationResource interface.
 */
export function instanceOfAdminCompanyLegalInformationResource(value: object): value is AdminCompanyLegalInformationResource {
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    return true;
}

export function AdminCompanyLegalInformationResourceFromJSON(json: any): AdminCompanyLegalInformationResource {
    return AdminCompanyLegalInformationResourceFromJSONTyped(json, false);
}

export function AdminCompanyLegalInformationResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminCompanyLegalInformationResource {
    if (json == null) {
        return json;
    }
    return {
        
        'companyId': json['companyId'],
        'name': json['name'] == null ? undefined : json['name'],
        'hqAddress': json['hqAddress'] == null ? undefined : CompanyAddressFromJSON(json['hqAddress']),
        'billingAddress': json['billingAddress'] == null ? undefined : CompanyAddressFromJSON(json['billingAddress']),
        'hqRegistrationNumber': json['hqRegistrationNumber'] == null ? undefined : json['hqRegistrationNumber'],
        'billingRegistrationNumber': json['billingRegistrationNumber'] == null ? undefined : json['billingRegistrationNumber'],
        'updatedDate': json['updatedDate'] == null ? undefined : (new Date(json['updatedDate'])),
        'vatNumber': json['vatNumber'] == null ? undefined : json['vatNumber'],
        'vatStatus': json['vatStatus'] == null ? undefined : VatStatusFromJSON(json['vatStatus']),
        'syncStatus': json['syncStatus'] == null ? undefined : json['syncStatus'],
        'syncComparison': json['syncComparison'] == null ? undefined : SyncComparisonFromJSON(json['syncComparison']),
        'providers': json['providers'] == null ? undefined : json['providers'],
    };
}

export function AdminCompanyLegalInformationResourceToJSON(value?: AdminCompanyLegalInformationResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'companyId': value['companyId'],
        'name': value['name'],
        'hqAddress': CompanyAddressToJSON(value['hqAddress']),
        'billingAddress': CompanyAddressToJSON(value['billingAddress']),
        'hqRegistrationNumber': value['hqRegistrationNumber'],
        'billingRegistrationNumber': value['billingRegistrationNumber'],
        'updatedDate': value['updatedDate'] == null ? undefined : ((value['updatedDate']).toISOString()),
        'vatNumber': value['vatNumber'],
        'vatStatus': VatStatusToJSON(value['vatStatus']),
        'syncStatus': value['syncStatus'],
        'syncComparison': SyncComparisonToJSON(value['syncComparison']),
        'providers': value['providers'],
    };
}

